package fr.frux.shared.domain.model

/**
 * Résumé de l'arbre porté par une récolte de proximité (#166) : le strict nécessaire pour
 * afficher une carte de liste sans redemander l'arbre complet.
 */
data class NearbyHarvestTreeSummary(
    val treeId: Long,
    val speciesCommonName: String,
    val treeStatus: TreeStatus,
)

/** Résumé du lieu porté par une récolte de lieu de proximité (ADR 0035). */
data class NearbyHarvestSiteSummary(
    val siteId: Long,
    val name: String,
    val accessRule: SiteAccessRule,
)

/**
 * Récolte à venir dans un rayon (#166), enrichie de la distance (calculée côté serveur) et d'un
 * résumé d'arbre — mêmes champs qu'[Harvest], sans le pas-à-pas complet d'une fiche.
 */
data class NearbyHarvest(
    val id: Long,
    val treeId: Long?,
    val createdBy: Long,
    // Même sémantique que Harvest.createdByUsername (#206).
    val createdByUsername: String? = null,
    val scheduledDate: Long,
    val description: String?,
    val participants: List<Long>,
    val status: HarvestStatus,
    val createdAt: Long?,
    val maxParticipants: Int? = null,
    val distanceMeters: Double,
    // Exactement un des deux résumés est posé : [tree] pour un arbre, [site] pour un lieu.
    val tree: NearbyHarvestTreeSummary?,
    // Même sémantique que Harvest.participantsDetails (#206).
    val participantsDetails: List<HarvestParticipant> = emptyList(),
    // Même sémantique que Harvest.participantsCount (#277), même piège sur copy().
    val participantsCount: Int = participants.size,
    val site: NearbyHarvestSiteSummary? = null,
    val hostedByOwner: Boolean = false,
) {
    /** Même règle que [Harvest.isFull] : `null` = sans limite, jamais pleine. */
    val isFull: Boolean
        get() = maxParticipants != null && participantsCount >= maxParticipants
}

/**
 * Lot de récoltes à proximité, avec le compte serveur total disponible dans le rayon interrogé
 * (#155, même patron que [NearbyTrees]).
 */
data class NearbyHarvests(
    val harvests: List<NearbyHarvest>,
    val totalAvailable: Int,
)
